export const LOGIN_TIMESTAMP_KEY = "loginTimestamp";